// extracted by mini-css-extract-plugin
module.exports = {"total":"_2rAfx_H"};